"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var dictionary_1 = require("./dictionary");
var Mode_1 = require("./Mode");
var Logger = (function () {
    function Logger() {
    }
    Logger.getMessage = function (key) {
        var message = lodash_1.get(dictionary_1.default, key);
        if (typeof message !== "undefined") {
            return Logger.PREFIX + message;
        }
        return Logger.PREFIX + key;
    };
    Logger.throw = function (key) {
        throw Error(Logger.getMessage(key));
    };
    Logger.error = function (key) {
        var message = "Error: " + Logger.getMessage(key);
        if (message && window.console) {
            console.error(message);
        }
    };
    Logger.debug = function (key) {
        var message = "Error: " + Logger.getMessage(key);
        if (message && window.console) {
            console.debug(key);
        }
    };
    Logger.warn = function (key) {
        if (Mode_1.currentMode.isDev()) {
            var message = "Warning: " + Logger.getMessage(key);
            if (message && window.console) {
                console.warn(message);
            }
        }
    };
    Logger.PREFIX = "TypeGraph - ";
    return Logger;
}());
exports.default = Logger;
//# sourceMappingURL=Logger.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/typegraph/dist/util/Logger.js
// module id = 256
// module chunks = 0